import React from "react";
import { Link } from "react-router-dom";

const RecentBlogsList = () => {
  return (
    <>
      <div className="details-info">
        <h5>Recent Blogs</h5>
        {RecentBlogData.map((data, index) => (
            <div className="rp-post-item d-flex" key={index}>
                <div className="col-lg-3 post-1">
                    <img src={data.img} alt="image1" />
                </div>
                <div className="col-lg-9 rp-post-info">
                    <Link to={data.link}>
                        <h6>{data.heading}</h6>
                    </Link>
                </div>
            </div>
        ))}
        
        
      </div>
    </>
  );
};

export default RecentBlogsList;

const RecentBlogData = [
     {
    img: require('../../../Assets/images/blog/headDesign/1.png'),
    link: '/1/BlogDetails',
    heading: 'How to Prepare for Your First IVF Cycle: A Step-by-Step Guide'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/2.png'),
    link: '/2/BlogDetails',
    heading: 'The Role of Genetics in IVF: What You Should Know'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/3.png'),
    link: '/3/BlogDetails',
    heading: 'IVF and Age: When is the Best Time to Start?'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/4.png'),
    link: '/4/BlogDetails',
    heading: 'The Latest Innovations in IVF Technology for 2024'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/5.png'),
    link: '/5/BlogDetails',
    heading: 'Importance of Mental Health Support During IVF Treatments'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/6.png'),
    link: '/6/BlogDetails',
    heading: 'Egg Freezing vs. IVF: Which is the Better Option for You?'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/7.png'),
    link: '/7/BlogDetails',
    heading: 'Unexpected Challenges in IVF: How to Navigate Secondary Infertility'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/8.png'),
    link: '/8/BlogDetails',
    heading: 'Natural Ways to Boost Fertility Before Considering IVF'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/9.png'),
    link: '/9/BlogDetails',
    heading: 'IVF Success Rates & Statistics: Understanding Your Chances'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/10.png'),
    link: '/10/BlogDetails',
    heading: 'PCOS and Fertility Explained: Understanding the Connection'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/11.png'),
    link: '/11/BlogDetails',
    heading: 'What is a Frozen Embryo Transfer (FET)?'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/12.png'),
    link: '/12/BlogDetails',
    heading: 'Fresh vs Frozen Embryo Transfer: Which is Better?'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/13.png'),
    link: '/13/BlogDetails',
    heading: 'Understanding IVF Fertility: A Journey of Hope and Science'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/14.png'),
    link: '/14/BlogDetails',
    heading: 'IVF and Relationships: Supporting Each Other Through the Journey'
  },
  {
    img: require('../../../Assets/images/blog/headDesign/15.png'),
    link: '/15/BlogDetails',
    heading: 'How Sleep and Mental Well-being Impact IVF Success'
  }
]